// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__2GukZ","title":"Card_title__9peP8","year":"Card_year__mjLz7","user":"Card_user__bnKJJ"};